export interface RawDevice {
    device_type_id: string;
    unique_device_id: string;
    rf_power: number;
    gateway_id: string;
}

export type SetupState = {
    rawDeviceList: RawDevice[];
};

export const initialSetupState: SetupState = {
    rawDeviceList: [],
};
